import React from 'react';
import HelpWalkthrough from '../shared/HelpWalkthrough';

// "How services work" walkthrough, opened from the `?` in the Services header.

const PeopleIcon = () => (
  <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <circle cx="9" cy="8" r="3" /><path d="M3 20a6 6 0 0 1 12 0" /><circle cx="17.5" cy="9" r="2.4" /><path d="M16 14.5a5 5 0 0 1 5 5" />
  </svg>
);
const PaletteIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M12 3a9 9 0 1 0 0 18c1.2 0 2-.9 2-2 0-1.3-1.2-1.8-1.2-3 0-.8.7-1.5 1.7-1.5H17a4 4 0 0 0 4-4c0-4.1-4-7.5-9-7.5z" />
    <circle cx="7.5" cy="11" r="1" fill="currentColor" stroke="none" /><circle cx="12" cy="8" r="1" fill="currentColor" stroke="none" /><circle cx="16" cy="10" r="1" fill="currentColor" stroke="none" />
  </svg>
);

const Toggle = () => (
  <span style={{ display: 'inline-flex', width: 46, height: 27, borderRadius: 999, background: '#007EA0', position: 'relative', flexShrink: 0 }}>
    <span style={{ position: 'absolute', top: 3, left: 22, width: 21, height: 21, borderRadius: '50%', background: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,.25)' }} />
  </span>
);

const SharingStage = () => (
  <div className="hw-ill" style={{ flexDirection: 'column', gap: 16 }}>
    <span className="hw-ill-badge"><PeopleIcon /></span>
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 10 }}>
      <span style={{ fontSize: 13, fontWeight: 700, color: '#29282D' }}>Enable to share</span>
      <Toggle />
    </span>
  </div>
);

const StaffTile = ({ initial, color, meta }) => (
  <div className="hw-ill-tile">
    <span style={{ width: 40, height: 40, borderRadius: 12, background: color, color: '#fff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 15 }}>{initial}</span>
    <span className="hw-ill-label" style={{ color: '#29282D', fontWeight: 700 }}>{meta}</span>
  </div>
);
const PerStaffStage = () => (
  <div className="hw-ill">
    <StaffTile initial="A" color="#007EA0" meta="£45 · 45m" />
    <StaffTile initial="J" color="#C2557A" meta="£60 · 60m" />
  </div>
);

const TimingsStage = () => (
  <div style={{ width: '78%' }}>
    <div style={{ display: 'flex', height: 32, borderRadius: 9, overflow: 'hidden', boxShadow: '0 6px 16px rgba(0,0,0,.07)' }}>
      <span style={{ flex: '0 0 18%', background: '#CFE6EC' }} />
      <span style={{ flex: 1, background: '#007EA0' }} />
      <span style={{ flex: '0 0 28%', background: '#9AD0DD' }} />
      <span style={{ flex: '0 0 16%', background: '#CFE6EC' }} />
    </div>
    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 9, fontSize: 10.5, color: '#8a8a90', fontWeight: 600 }}>
      <span>Setup</span><span>Service</span><span>Processing</span><span>Cleanup</span>
    </div>
  </div>
);

const ColoursStage = () => (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
    <span className="hw-ill-badge"><PaletteIcon /></span>
    <div className="hw-ill-swatches">
      {['#C8EEEE', '#F7C9D9', '#FCE0A8', '#CDE3FF', '#D8CBF0'].map((c) => (
        <span key={c} className="hw-ill-swatch" style={{ background: c }} />
      ))}
    </div>
  </div>
);

const SLIDES = [
  {
    key: 'sharing',
    title: 'Sharing and self-employed',
    body: 'New services start switched off. Turn on sharing to make a service bookable, and if you are self-employed you will need to enable each service you offer before it shows on your page.',
    Stage: SharingStage,
  },
  {
    key: 'per-staff',
    title: 'Set up per team member',
    body: 'Every service is configurable by team member. Each person can have their own price and time, so a senior and a junior can offer the same service at the rate that suits them.',
    Stage: PerStaffStage,
  },
  {
    key: 'timings',
    title: 'Build in prep and tidy-up time',
    body: 'On top of the service time, add setup time before, processing time during (while colour develops), finishing time after processing (rinse, tone, blow-dry), and cleanup time after. The diary blocks the chair correctly and can slot another client into the processing gap.',
    Stage: TimingsStage,
  },
  {
    key: 'colours',
    title: 'Make the diary yours with colour',
    body: 'Give each service its own diary colour so your day reads at a glance. Mix and match to make the diary feel like yours.',
    Stage: ColoursStage,
  },
];

const ServiceHelp = ({ onClose }) => (
  <HelpWalkthrough eyebrow="How services work" slides={SLIDES} onClose={onClose} />
);

export default ServiceHelp;
